import React, { useState } from "react";
import VehicleDetail from "../pages/Vehicle/VehicleDetail";
import VehicleList from "../pages/Vehicle/VehicleList";

const VehicleModal = (props) => {
  var [method] = useState(1);

  function selectVehicle(vehicle) {
    var v = { ...vehicle };
    if (method == 2) {
      // v.brand = state.brand.items.find(brand => brand.uuid == v.brand);
      // v.brandModel = state.brandModel.items.find(
      //   brandModel => brandModel.uuid == v.brandModel
      // );
    }
    document.getElementById("close-vehicle-modal").click();
    props.selectVehicle(v);
  }

  var content =
    method == 1 ? (
      <VehicleList modal={true} selectVehicle={selectVehicle} />
    ) : (
      <VehicleDetail modal={true} selectVehicle={selectVehicle} />
    );

  return (
    <>
      <button
        type="button"
        className="btn btn-primary"
        data-toggle="modal"
        data-target="#vehicleModal"
      >
        {props.selectedVehicle
          ? props.selectedVehicle.brand.name +
            " " +
            props.selectedVehicle.brandModel.name +
            " (" +
            props.selectedVehicle.immat +
            ")"
          : "Choisir un véhicule"}
      </button>
      <div
        className="modal fade"
        id="vehicleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div
          className="modal-dialog"
          role="document"
          style={{ maxWidth: "100%" }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Sélection du véhicule
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {/* <ul className="nav nav-tabs">
                <li className="nav-item">
                  <a
                    className={"nav-link " + (method == 1 && "active")}
                    href="#"
                    onClick={() => setMethod(1)}
                  >
                    Rechercher
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className={"nav-link " + (method == 2 && "active")}
                    href="#"
                    onClick={() => setMethod(2)}
                  >
                    Créer
                  </a>
                </li>
              </ul> */}
              <div className="mt-4">{content}</div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
                id="close-vehicle-modal"
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VehicleModal;
